import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
//import { Observable } from 'rxjs/Observable/';
//import { Subject } from 'rxjs/Subject';
import { AppSettings } from 'read-appsettings-json';
import { UtilityServices, CheckAuth } from '../../../Services/UtilityService';
import { LoginComponent } from '../../login/login.component';

@Component({
  selector: 'app-site-layout',
  templateUrl: './site-layout.component.html',
  styleUrls: ['./site-layout.component.css']
})
export class SiteLayoutComponent implements OnInit {
  appModel: any;
  showMenu: boolean;
  userID: number = 0;
  showLogin: boolean;

  constructor(private router: Router, private location: Location, private checkAuth: CheckAuth, private logincomp: LoginComponent) {    
    this.appModel = AppSettings.Current().ConnectionStrings;
    this.userID = +this.logincomp.GetplainText(sessionStorage.getItem('UserId'));    
    router.events.forEach((event) => {      
      if (event instanceof NavigationEnd) {
        //this.showMenu = true;
        this.showMenu = event.url !== "/Basic-Preference" && event.url !== "/Hazard-Preference";
        this.showLogin = event.url !== "/login" && event.url !== "/";        
      }
    });
    
  }

  ngOnInit() {    
    //if (this.utilities.isLogged()) {
    //  this.isLogin = true;
    //}
    //else {
    //  this.isLogin = false;
    //}
    sessionStorage.setItem('BaseURL', this.appModel.BaseURL);
    this.GetToken();
  }

  GetToken(): void {
    this.checkAuth.GetToken();
  }
  logout(): void {
    sessionStorage.removeItem('UserId');
    this.router.navigate(['/login']);
  }

}
